<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  modelValue: string[]
  options: Record<string, string>
  title: string
  searchable?: boolean
}>()

const emit = defineEmits<(e: 'update:modelValue', value: string[]) => void>()

const agentOptions = computed(() =>
  Object.entries(props.options)
    .map(([value, label]) => ({ value, label }))
    .sort((a, b) => a.label.localeCompare(b.label)),
)

const selected = computed({
  get: () => props.modelValue,
  set: (value: string[]) => {
    emit('update:modelValue', value)
  },
})
</script>

<template>
  <ODropdown
    v-model="selected"
    :options="agentOptions"
    :searchable="props.searchable"
    medium
    multi-select
    :filter-title="props.title"
    filter
  />
</template>
